"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importStar(require("react"));
var utilities_1 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  overflow: hidden;\n  margin: 0 auto;\n"], ["\n  overflow: hidden;\n  margin: 0 auto;\n"])));
var Iframe = styled_components_1["default"].iframe(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var WidgetVoting = /** @class */ (function (_super) {
    tslib_1.__extends(WidgetVoting, _super);
    function WidgetVoting(props) {
        var _this = _super.call(this, props) || this;
        _this.iframe = null;
        return _this;
    }
    WidgetVoting.prototype.componentDidMount = function () {
        if (!window.votingIframeResizer) {
            window.votingIframeResizer = function (event) {
                var iframeWrapper = document.getElementById("voting_" + utilities_1.getProp(event, [
                    'data',
                    'votingContainerSize',
                    'votingId',
                ]) + "_wrapper");
                if (!'https://hlasovanie.sportnet.online/hlasuj/'.startsWith(event.origin)) {
                    return;
                }
                if (event.data.votingContainerSize) {
                    if (iframeWrapper) {
                        iframeWrapper.style.height = event.data.votingContainerSize
                            .height + 80 + "px";
                    }
                }
                if (event.data.votingContainerScroll) {
                    document
                        .getElementById("voting_" + utilities_1.getProp(event, [
                        'data',
                        'votingContainerSize',
                        'votingId',
                    ]) + "_wrapper")
                        .scrollIntoView(true);
                }
            };
            window.votingIframeScrolltop = function (iframe) {
                var iframeId = iframe.getAttribute('id');
                if (!window.votingIframeScrolltopCounter[iframeId]) {
                    window.votingIframeScrolltopCounter[iframeId] = 1;
                }
                else {
                    window.votingIframeScrolltopCounter[iframeId] += 1;
                }
                if (window.votingIframeScrolltopCounter[iframeId] > 1) {
                    iframe.scrollIntoView(true);
                }
            };
            window.votingIframeScrolltopCounter = {};
            window.addEventListener('message', window.votingIframeResizer, false);
        }
    };
    WidgetVoting.prototype.render = function () {
        var _this = this;
        var id = this.props.data.id;
        return (react_1["default"].createElement(Wrapper, null,
            react_1["default"].createElement(Iframe, { id: "voting_" + id + "_wrapper", ref: function (iframe) {
                    _this.iframe = iframe;
                }, src: "https://hlasovanie.sportnet.online/hlasuj/" + id, frameBorder: "0", allowFullScreen: true })));
    };
    return WidgetVoting;
}(react_1.PureComponent));
WidgetVoting.propTypes = {
    data: prop_types_1["default"].shape({
        id: prop_types_1["default"].string.isRequired
    }).isRequired
};
exports["default"] = WidgetVoting;
var templateObject_1, templateObject_2;
